import type { ITimesheetWeekResponse } from '@pulse/shared';

import { apiFetch } from '../../../lib/api-client';
import { extractErrorMessage } from '../../../lib/api-error.util';

export async function fetchMyTimesheetWeek(weekStart?: string): Promise<ITimesheetWeekResponse> {
  const qs = weekStart ? `?weekStart=${weekStart}` : '';
  const res = await apiFetch(`/api/v1/timesheet/me${qs}`);
  if (!res.ok) throw new Error(await extractErrorMessage(res, 'Failed to fetch your timesheet'));
  return res.json() as Promise<ITimesheetWeekResponse>;
}

// Submit — omit projectId to submit every project relevant to this week at once.
export async function submitTimesheet(weekStart: string, projectId?: string): Promise<void> {
  const res = await apiFetch('/api/v1/timesheet/me/submit', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ weekStart, projectId }),
  });
  if (!res.ok) throw new Error(await extractErrorMessage(res, 'Failed to submit timesheet'));
}
